<template>
  <div class="playback-play-button">
    <tooltip class="description-top" :tooltip-text="description">
      <div class="play-icon" @click="onClick">
        <play-arrow-icon v-show="isShowPlayArrowIcon"></play-arrow-icon>
        <pause-icon v-show="isShowPauseIcon"></pause-icon>
        <replay-icon v-show="isShowReplayIcon"></replay-icon>
      </div>
    </tooltip>
  </div>
</template>

<script>
import C from "../../../Constants";
import PlayArrowIcon from "./PlayArrowIcon.vue";
import ReplayIcon from "./ReplayIcon.vue";
import PauseIcon from "./PauseIcon.vue";
import Tooltip from "../Tooltip.vue";

export default {
  name: "PlayButton",
  components: {
    PlayArrowIcon,
    ReplayIcon,
    PauseIcon,
    Tooltip,
  },
  props: ["playbackStatus"],
  computed: {
    mPlaybackStatus() {
      if (this.playbackStatus === undefined) return C.PLAYBACK_STATUS.PAUSE;
      return this.playbackStatus;
    },
    isShowPlayArrowIcon() {
      return this.mPlaybackStatus === C.PLAYBACK_STATUS.PAUSE;
    },
    isShowPauseIcon() {
      return this.mPlaybackStatus === C.PLAYBACK_STATUS.PLAY;
    },
    isShowReplayIcon() {
      return !(this.isShowPlayArrowIcon || this.isShowPauseIcon);
    },
    description() {
      if (this.isShowPlayArrowIcon) return "再生";
      if (this.isShowPauseIcon) return "一時停止";
      return "もう一度再生する";
    },
  },
  methods: {
    onClick() {
      if (this.isShowPauseIcon) {
        this.$emit("pause");
      } else if (this.isShowPlayArrowIcon) {
        this.$emit("play");
      } else {
        this.$emit("rePlay");
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

.playback-play-button {
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;

  .play-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 44px;
    width: 44px;
    ::v-deep svg path {
      fill: $aisea-blue;
    }
    &:hover {
      ::v-deep svg path {
        fill: #328dc0;
      }
    }
    &:active {
      ::v-deep svg path {
        fill: #2075a6;
      }
    }
  }
}
</style>
